module.exports = __webpack_public_path__ + "img/96.d46d2a1b.png";